export default __webpack_public_path__ + "static/media/chime.47fbf81c.wav";